import React from 'react';
import styled from 'styled-components';
import propTypes from 'prop-types';
import Button from '@mui/material/Button';
import { TextField } from '@mui/material';
import { useState, useEffect, useLayoutEffect } from 'react';
import { StyledButton } from '../../../../Components/Generics.styled';

const WebsiteConfirmContainer = styled.div`
    margin-top: 100px;
    display: flex;
    height: 350px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
`;

const Title = styled.div`
    font-size: 23px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    width: 100%;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
`;

const EnterWebsiteSection = styled.div`
    margin-left: auto;
    margin-right: auto;
    height: 700px;
    width: 100%;
    display: flex;
    flex-direction: column;
`;

const EnterWebsiteInput = styled.div`
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    height: 100px;
    display: flex;
    flex-direction: row;
    margin-top: 10px;
    width: 100%;

    .MuiOutlinedInput-root {
        background-color: #fafbf7;
    }
`;

const StyledNavButtons = styled.div`
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 160px;
    margin-left: auto;
    margin-right: auto;
`;

const StyledTextField = styled(TextField)`
    width: 100%;
    max-width: 400px;
`;
const WebsiteConfirm = (props) => {
    const {
        setPageIndex,
        campaignData,
        setCampaignData,
        handleNavButtonBack,
        handleNavButtonNext,
        currentAdvertiser,
    } = props;

    const formattedSubdomain = currentAdvertiser?.companyName
        ?.replace(/\s+/g, '')
        .replace(/'/g, '')
        .toLowerCase();

    // const baseURL = `http://${formattedSubdomain}.localhost:3001`;
    // const baseURL = `https://${formattedSubdomain}.lifewiseleadsapp.com`;
    // const apiKey = '1234';
    // const { data: getConfigData, mutate } = useRequest(
    //     `${baseURL}/api/config?subdomain=${formattedSubdomain}&apiKey=${apiKey}`,
    //     undefined,
    //     false
    // );

    // const noConfig = getConfigData?.config === null;

    const [urlLink, setUrlLink] = useState('');

    const [urlLinkError, setUrlLinkError] = useState({
        isValid: false,
        errorMessage: '',
    });

    const handleCheckWebsiteLink = () => {
        window.open(
            urlLink,
            '_blank',
            'location=yes,height=570,width=520,scrollbars=yes,status=yes'
        );
    };

    const handleNextRoute = () => {
        setCampaignData({ ...campaignData, websiteURL: urlLink });
        handleNavButtonNext();
    };

    const determineBackRoute = () => {
        handleNavButtonBack();
    };

    const regex =
        /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi;

    const handleWebsiteLink = () => {
        if (urlLink.match(regex)) {
            setUrlLinkError({ ...urlLinkError, isValid: true, errorMessage: '' });
        } else {
            setUrlLinkError({
                ...urlLinkError,
                isValid: false,
                errorMessage: 'URL must be in this format https://websitename.com',
            });
        }
    };

    useEffect(() => {
        setUrlLink(campaignData.websiteURL);
    }, []);

    useEffect(() => {
        handleWebsiteLink();
    }, [urlLink]);

    // useLayoutEffect(() => {
    //     // need to useLayoutEffect here because of async issue. This acts as OG componentDidMount
    //     if (noConfig === false) {
    //         setUrlLink(`https://${formattedSubdomain}.lifewiseleadsapp.com`);
    //     } else {
    //         setUrlLink('');
    //     }
    // }, [getConfigData]);

    return (
        <WebsiteConfirmContainer>
            <Title>
                Enter the Website URL that customers will be directed to when they click your Ad.
            </Title>
            <br />
            <br />
            <EnterWebsiteSection>
                <EnterWebsiteInput>
                    <StyledTextField
                        id="Website-Url"
                        label="Website URL"
                        value={urlLink}
                        onChange={(e) => setUrlLink(e.target.value)}
                        variant="outlined"
                        error={urlLink === '' || !urlLinkError.isValid}
                        placeholder="https://www.example.com"
                        helperText={urlLinkError.errorMessage}
                    />
                    <StyledButton
                        style={{ marginLeft: '30px' }}
                        variant="contained"
                        color="primary"
                        onClick={() => handleCheckWebsiteLink()}
                        disabled={urlLink === '' || !urlLinkError.isValid}
                    >
                        Check Website URL Link
                    </StyledButton>
                </EnterWebsiteInput>
            </EnterWebsiteSection>
            <StyledNavButtons>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => determineBackRoute()}
                >
                    Back
                </StyledButton>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNextRoute()}
                    disabled={urlLink === '' || !urlLinkError.isValid}
                >
                    Next
                </StyledButton>
            </StyledNavButtons>
        </WebsiteConfirmContainer>
    );
};

WebsiteConfirm.propTypes = {
    campaignData: propTypes.shape({
        campaignTypeName: propTypes.string,
        websiteURL: propTypes.string,
    }),
    setCampaignData: propTypes.func,
    handleNavButtonNext: propTypes.func,
    handleNavButtonBack: propTypes.func,
    setPageIndex: propTypes.func,
    currentAdvertiser: propTypes.shape({
        companyName: propTypes.string,
    }),
};

WebsiteConfirm.defaultProps = {
    campaignData: {},
    setCampaignData: () => {},
    handleNavButtonNext: () => {},
    handleNavButtonBack: () => {},
    setPageIndex: () => {},
};

export default WebsiteConfirm;
